import { useState, useRef, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { setPlayers, setSearch, usePlayers } from "../../ducks/players";
import Page from "../../components/Page";
// import Fuse from "../../components/Fuse";
import styles from "./Players.module.css";
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaChessQueen } from "@react-icons/all-files/fa/FaChessQueen";
import { FaCaretDown } from "@react-icons/all-files/fa/FaCaretDown";
import { FaEnvelope } from "@react-icons/all-files/fa/FaEnvelope";
import { FaUserFriends } from "@react-icons/all-files/fa/FaUserFriends";
import Head from "next/head";
import ChallengePopup from "../challenge/ChallengePopup";
import Link from "next/link";
import { useUser } from "../../ducks/user";
import { useChallenges } from "../../ducks/challenges";
import AdSense from "../../components/AdSense";

// function renderAd(id) {
//   return <Fuse showRemoveAds={false} id={id} adStyles={styles.ad} />;
// }

function renderAd() {
  return (
    <AdSense
      adStyles={styles.ad}
      showRemoveAds={false}
      slot="3600357831"
      format="auto"
      insStyle={{ width: "100%" }}
    />
  );
}

export default function Players() {
  const { t } = useTranslation("common");

  const { players, search } = usePlayers();
  const { username } = useUser();
  const { sentChallenges } = useChallenges();

  const [challengeUsername, setChallengeUsername] = useState(null);
  const [ratingsDesc, setRatingsDesc] = useState(true);
  const [playersDesc, setPlayersDesc] = useState(null);
  const [playingDesc, setPlayingDesc] = useState(null);
  const [nrPlayers, setNrPlayers] = useState(100);

  const [challengeOpen, setChallengeOpen] = useState(false);

  const playersEl = useRef(null);

  useEffect(() => {
    sortRatings();

    if (window.fusetag) {
      window.fusetag.loadSlots();
    }
  }, []);

  useEffect(() => {
    function updatePlayers() {
      if (
        playersEl.current &&
        playersEl.current.getBoundingClientRect().bottom <= window.innerHeight
      ) {
        if (nrPlayers < players.length) {
          setNrPlayers((nrPlayers) => nrPlayers + 100);
        }
      }
    }
    window.addEventListener("scroll", updatePlayers);

    return () => {
      window.removeEventListener("scroll", updatePlayers);
    };
  }, [nrPlayers, players]);

  // function renderAd(id) {
  //     return <Fuse showRemoveAds={false} id={id} adStyles={styles.ad} />;
  // }

  // function renderAdFooter(id) {
  //     return (
  //       <Fuse id={id} adStyles={styles.footerAd} />
  //     );
  // }

  // function renderStickyAd(id) {
  //   if (isDesktop) {
  //     return (
  //       <div className={styles.stickyAd}>
  //         <Fuse showRemoveAds={false} adStyles={null} id={id} />
  //       </div>
  //     );
  //   }
  // }

  function challengePlayer(username) {
    setChallengeUsername(username);
    setChallengeOpen(true);
  }

  function getDisplayName(name: string) {
    if (!name) {
      return "";
    }
    return name.length >= 2 && name.substring(0, 2) === "G*"
      ? name.substring(2)
      : name;
  }

  function renderPlayers() {
    let filteredPlayers =
      search === ""
        ? players
        : players.filter((player) => {
            const name = getDisplayName(player.u);
            return name.startsWith(search);
          });

    filteredPlayers = filteredPlayers.slice(0, nrPlayers);

    return filteredPlayers.map((player, index) => {
      const isChallenged = sentChallenges.indexOf(player.u) >= 0;
      const isPlaying = player.p;

      const isMe = username === player.u;
      const name = getDisplayName(player.u);
      const play = isPlaying ? (
        <span title={t("Playing")}>
          <FaChessQueen />
        </span>
      ) : (
        <span
          onClick={() => challengePlayer(player.u)}
          className="text-blue-500 cursor-pointer"
        >
          <FaEnvelope />
        </span>
      );

      const nameTag =
        isChallenged && !isPlaying ? (
          <td>
            <div className="flex items-center space-x-1">
              <FaEnvelope />
              {player.g ? (
                <div>{name}</div>
              ) : (
                <Link href={"/user?userId=" + player.id + "&link=players"}>
                  <a className="text-orange-400">{name}</a>
                </Link>
              )}
            </div>
          </td>
        ) : (
          <td>
            {player.g ? (
              name
            ) : (
              <Link href={"/user?userId=" + player.id + "&link=players"}>
                <a className="text-orange-400">{name}</a>
              </Link>
            )}
          </td>
        );
      return (
        <tr key={player.u}>
          {nameTag}
          <td>{player.elo}</td>
          <td>{!isChallenged && !isMe && play}</td>
        </tr>
      );
    });
  }

  function sortPlayers() {
    const desc = playersDesc != null ? playersDesc : true;

    const toSort = [...players];

    toSort.sort((a, b) => {
      const aName = getDisplayName(a.u);
      const bName = getDisplayName(b.u);
      if (desc) {
        if (aName < bName) return -1;
        if (aName > bName) return 1;
      } else {
        if (aName < bName) return 1;
        if (aName > bName) return -1;
      }
      return 0;
    });
    setPlayers(toSort);
    setPlayersDesc(!desc);
    setRatingsDesc(null);
    setPlayingDesc(null);
  }

  function sortRatings() {
    const desc = ratingsDesc != null ? ratingsDesc : true;
    const toSort = [...players];
    toSort.sort((a, b) => {
      if (desc) {
        return -(a.elo - b.elo);
      } else {
        return a.elo - b.elo;
      }
    });
    setPlayers(toSort);
    setPlayersDesc(null);
    setRatingsDesc(!desc);
    setPlayingDesc(null);
  }

  function sortPlaying() {
    const desc = playingDesc != null ? playingDesc : true;

    const toSort = [...players];

    toSort.sort((a, b) => {
      if (desc) {
        return a.p - b.p;
      } else {
        return -(a.p - b.p);
      }
    });
    setPlayers(toSort);
    setPlayersDesc(null);
    setRatingsDesc(null);
    setPlayingDesc(!desc);
  }

  const playersArrow = playersDesc ? styles.arrowActive : styles.arrow;
  const ratingsArrow = ratingsDesc ? styles.arrowActive : styles.arrow;
  const playingArrow = playingDesc ? styles.arrowActive : styles.arrow;

  const right = (
    <div className="relative flex items-center">
      <div className="absolute text-orange-400 right-3">
        <FaSearch />
      </div>
      <input
        className="border border-lines rounded p-2 w-40 md:w-64 text-sm"
        type="text"
        onChange={(event) => setSearch(event.target.value)}
      />
    </div>
  );

  return (
    <div className={styles.mainCont}>
      <Head>
        <title>Chess Hotel | {t("Players")}</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      {/* {renderAd()} */}
      <Page title={t("Players")} icon={<FaUserFriends />} right={right}>
        {challengeOpen && (
          <ChallengePopup
            player={challengeUsername}
            onClose={() => setChallengeOpen(false)}
          />
        )}
        <div className={styles.cont}>
          <div className={styles.players} ref={playersEl}>
            <table className={styles.playersTable}>
              <thead>
                <tr>
                  <th onClick={sortPlayers}>
                    {t("Player")}
                    {playersDesc != null && (
                      <div className={playersArrow}>
                        <FaCaretDown />
                      </div>
                    )}
                  </th>
                  <th onClick={sortRatings}>
                    {t("Rating")}
                    {ratingsDesc != null && (
                      <div className={ratingsArrow}>
                        <FaCaretDown />
                      </div>
                    )}
                  </th>
                  <th onClick={sortPlaying}>
                    {t("Invite")}
                    {playingDesc != null && (
                      <div className={playingArrow}>
                        <FaCaretDown />
                      </div>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>{renderPlayers()}</tbody>
            </table>

            {/* {renderStickyAd("players_vrec_1")} */}
          </div>
        </div>
      </Page>
      {/* {this.renderAdFooter("21956403076")} */}
    </div>
  );
}

// function areEqual(prevProps, nextProps) {
//   /*
//   return true if passing nextProps to render would return
//   the same result as passing prevProps to render,
//   otherwise return false
//
//
//   */
//   return Date.now() - nextProps.lastUpdate < 5000;
// }
